import { useEffect, useRef, useState } from "react";
// Redux
import { useDispatch, useSelector } from "react-redux";
//Components
import { Button, Input, translateMessage } from "@delibrandev/utils";
import { deleteAllVariants, deleteVariant, getProduct, updateVariant } from "../../../../../api/products";
import { setAlert, setLoading, updateDatatableCheckColumn, updateFloatPanelData } from "../../../../../reducers/userConfigSlice";
import { SwitchText } from "@delibrandev/utils";
import { MdEuro } from "react-icons/md";
import { OptionsHandler } from "./options/optionsHandler";

export const Variants = ({ compact = false }) => {
  const dispatch = useDispatch();
  const idProduct = useSelector((state) => state.aplicationConfig.userConfig.floatPanel.queryId);
  const variants = useSelector((state) => state.aplicationConfig.userConfig.floatPanel.data.variants);
  const [modalOptionsOpen, setModalOptionsOpen] = useState(false);
  const [deletingAll, setDeletingAll] = useState(false);
  const deleteInProgress = useRef(false);
  const identificator = "products-variants-" + idProduct;

  const togglePopup = () => {
    setModalOptionsOpen(!modalOptionsOpen);
  };

  const query = async () => {
    const response = await getProduct(idProduct);
    if (response && !response.error) {
      dispatch(updateFloatPanelData({ data: response.data.variants, name: "variants" }));
      dispatch(updateFloatPanelData({ data: response.data.options, name: "options" }));
      return true;
    } else {
      dispatch(setAlert(translateMessage(response?.message || "Bad request")));
    }
    return false;
  };

  const removeAllVariants = async () => {
    if (deleteInProgress.current) return;
    deleteInProgress.current = true;
    setDeletingAll(true);
    try {
      const response = await deleteAllVariants(idProduct);
      if (response && !response.error) {
        if (await query()) dispatch(setAlert(translateMessage(response.message)));
      } else {
        dispatch(setAlert(translateMessage(response?.message || "Bad request")));
      }
    } catch {
      dispatch(setAlert(translateMessage("Bad request")));
    } finally {
      deleteInProgress.current = false;
      setDeletingAll(false);
    }
  };

  const removeVariant = async (variantId) => {
    const response = await deleteVariant(idProduct, variantId);
    if (response && !response.error) {
      query();
    } else if (response && response.data === "Not found") {
      console.log("Not found");
    } else {
      console.log("ELSE RESPONSE");
      console.log(response);
    }
  };

  const updateVariantQuery = async (variant, index, image = null) => {
    console.log("==> updateVariantQuery");
    const inputElement = document.getElementById(`variant-img-${index}`);
    console.log(inputElement);
    const file = image === null ? inputElement?.files?.[0] : image;

    const payload = {
      name: /*document.getElementById("variantName-" + variant.variantId).value*/ "",
      description: "",
      isActive: !document.getElementById("variantActive-" + variant.variantId).checked,
      price: document.getElementById("variantPrice-" + variant.variantId).value || 0,
      files: [file],
    };
    console.log(payload);
    dispatch(setLoading(true));
    const response = await updateVariant(variant.variantId, payload);
    if (response && !response.error) {
      dispatch(setAlert(translateMessage(response?.message || "Bad request")));
      console.log("get", response.data);
    } else if (response && response.data === "Not found") {
      dispatch(setAlert(translateMessage(response?.message || "Bad request")));
      console.log("Not found");
    } else {
      console.log("ELSE RESPONSE");
      dispatch(setAlert(translateMessage(response?.message || "Bad request")));
      console.log(response);
    }
    dispatch(setLoading(false));
  };

  useEffect(() => {
    dispatch(updateDatatableCheckColumn({ checkColumn: true, table: identificator }));
    query();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleImage = (e, position, variant) => {
    console.log("==> handleImage");
    const label = e.target.parentElement;
    const file = e.target.files[0];

    if (file) {
      updateVariantQuery(variant, position, file);
      const reader = new FileReader();
      reader.onload = (e) => {
        // Establece la imagen como fondo del label
        label.style.color = "white"; // Cambia el color del texto si es necesario
        const elements = document.getElementsByClassName("background-image-" + position);
        if (elements.length > 0) {
          elements[0].style.backgroundImage = `url(${e.target.result})`;
        }
      };
      reader.readAsDataURL(file); // Leer el archivo original como una URL base64
    }
  };

  return (
    <>
      <div className="flex-gap">
        <div className="inputDescription">Variantes basadas en la combinación de todas las opciones</div>
        <div style={{ marginTop: "-20px", marginBottom: "10px" }}>
          <div className="flex-gap">
            <Button text={compact ? "Configurar opciones" : "Opciones"} icon={null} customClass={"customButtonColor2"} action={togglePopup} disabled={deletingAll} />
            {(!compact || variants?.length > 0) && <Button text={deletingAll ? "Eliminando…" : "Eliminar todas"} icon={null} customClass={"customButtonColor1"} action={removeAllVariants} disabled={deletingAll} />}
          </div>
        </div>
      </div>

      <div className="variants-list">
        {variants && variants.length > 0 ? (
          variants.map((variant, index) => (
            <div className={`variant-type ${variant.isActive && "variant-type-active"}`} key={variant.variantId}>
              <div className="product-image" style={{ width: "15%", height: "35px", display: "flex", gap: "10px" }}>
                <label
                  className={`product-image-featured background-image-${index}`}
                  style={{ backgroundImage: `url('${variant?.images && variant?.images.length > 0 ? variant?.images[0] : ""}')` }}
                  htmlFor={`variant-img-${index}`}
                >
                  <span className="product-image-label" style={{ width: "50px", height: "50px" }}></span>
                  {/*<InputImage uniqueId={"variantImg-" + index} className={"product-image-featured"} image={null} />*/}
                  <input
                    type="file"
                    id={`variant-img-${index}`}
                    style={{ display: "none" }}
                    onChange={(e) => handleImage(e, index, variant)}
                  />
                </label>
              </div>
              <div
                className="variant-name"
                style={{ display: "flex", justifyContent: "flex-start", alignItems: "center", gap: "5px" }}
              >
                {/*variant.options.map((opt, optIdx) => (
                  <div key={"variant-name" + optIdx}>{`${
                    opt.optionGroup.name?.charAt(0).toUpperCase() + opt.optionGroup.name?.slice(1)
                  }: ${opt.name?.charAt(0).toUpperCase() + opt.name?.slice(1)}`}</div>
                ))*/}
                {variant.options.map((opt, optIdx) => (
                  <div
                    key={"variant-name" + optIdx + index}
                  >{`${opt.name?.charAt(0).toUpperCase() + opt.name?.slice(1)}${optIdx < variant.options.length - 1 ? ", " : ""}`}</div>
                ))}
              </div>
              <div className="variant-price">
                <Input
                  id={"variantPrice-" + variant.variantId}
                  type={"text"}
                  placeholder=""
                  icon={<MdEuro />}
                  classname={""}
                  iconPositionRight={true}
                  label=""
                  description=""
                  onChange={() => updateVariantQuery(variant, index)}
                  defaultValue={variant.price || "0"}
                />
              </div>
              <div className="variant-active">
                {" "}
                <SwitchText
                  id={"variantActive-" + variant.variantId}
                  defaultChecked={variant.isActive}
                  onChange={() => updateVariantQuery(variant, index)}
                />
                <Button
                  text={"Eliminar"}
                  icon={null}
                  customClass={"customButtonColor1"}
                  action={() => removeVariant(variant.variantId)}
                />
              </div>
            </div>
          ))
        ) : (
          <div className="p-1">No hay variantes, crea algún atributo y opción.</div>
        )}
      </div>
      {modalOptionsOpen && <OptionsHandler togglePopup={togglePopup} isOpen={modalOptionsOpen} />}
    </>
  );
};
